import { createContext } from 'react'
import type { ContactCenterUserContext } from '@ucc/admin-global-state'

export interface ContactCenterUserContextValue {
  userContext: ContactCenterUserContext | null
}

export default createContext<ContactCenterUserContextValue>({ userContext: null })
